import script from "./TopPreSalePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopPreSalePanel.vue?vue&type=script&setup=true&lang=ts"

import "./TopPreSalePanel.vue?vue&type=style&index=0&id=1a381165&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a381165"]])

export default __exports__